import axios from "axios"
import localforage from "localforage"
import memoryDriver from "localforage-memoryStorageDriver"
import { setupCache, setup } from "axios-cache-adapter"
import tokenService from "@/helpers/tokenService.js"
import appConfig from "@/helpers/appConfig.js"

const axiosAuthConfig = {
  withCredentials: appConfig.axios().withCredentials,
  withXSRFToken: appConfig.axios().withXSRFToken
}

if (!appConfig.isProductionBuild) {
  axios.defaults.headers.common["Authorization"] =
    appConfig.axios().Authorization
}
localforage.defineDriver(memoryDriver)
// Create `localforage` instance
const forageStore = localforage.createInstance({
  // List of drivers used
  driver: [
    localforage.INDEXEDDB,
    localforage.LOCALSTORAGE,
    memoryDriver._driver
  ],
  // Prefix all storage keys to prevent conflicts
  name: "e-hallpass-" + tokenService.getToken()
})

// Advance reporting cache store: fixed name (no token) so cache persists after login redirect
const advanceReportingForageStore = localforage.createInstance({
  driver: [
    localforage.INDEXEDDB,
    localforage.LOCALSTORAGE,
    memoryDriver._driver
  ],
  name: "e-hallpass-advance-reporting"
})
const configure = async function () {
  // Register the custom `memoryDriver` to `localforage`
  await localforage.defineDriver(memoryDriver)

  // Create `axios` instance with pre-configured `axios-cache-adapter` using a `localforage` store
  return setup({
    // `axios` options
    baseURL: appConfig.api + "v5",
    headers: {
      common: {
        Accept: "application/json, text/plain, */*"
      }
    },
    withCredentials: axiosAuthConfig.withCredentials,
    withXSRFToken: axiosAuthConfig.withXSRFToken,
    //Define Cache setting and invalidation
    cache: {
      maxAge: 30 * 60 * 1000,
      exclude: { query: false },
      store: forageStore,
      invalidate: async (config, request) => {
        if (request.clearCacheEntry) {
          await config.store.removeItem(config.uuid)
        }
      }
    }
  })
}
const configure6 = async function () {
  // Register the custom `memoryDriver` to `localforage`
  await localforage.defineDriver(memoryDriver)

  // Create `axios` instance with pre-configured `axios-cache-adapter` using a `localforage` store
  return setup({
    // `axios` options
    baseURL: appConfig.api + "v6",
    headers: {
      common: {
        Accept: "application/json, text/plain, */*"
      }
    },
    withCredentials: axiosAuthConfig.withCredentials,
    withXSRFToken: axiosAuthConfig.withXSRFToken,
    //Define Cache setting and invalidation
    cache: {
      maxAge: 30 * 60 * 1000,
      exclude: { query: false },
      store: forageStore,
      invalidate: async (config, request) => {
        if (request.clearCacheEntry) {
          await config.store.removeItem(config.uuid)
        }
      }
    }
  })
}
const configure7 = async function () {
  // Register the custom `memoryDriver` to `localforage`
  await localforage.defineDriver(memoryDriver)

  // Create `axios` instance with pre-configured `axios-cache-adapter` using a `localforage` store
  return setup({
    // `axios` options
    baseURL: appConfig.api + "v7",
    headers: {
      common: {
        Accept: "application/json, text/plain, */*"
      }
    },
    withCredentials: axiosAuthConfig.withCredentials,
    withXSRFToken: axiosAuthConfig.withXSRFToken,
    //Define Cache setting and invalidation
    cache: {
      maxAge: 30 * 60 * 1000,
      exclude: { query: false },
      store: forageStore,
      invalidate: async (config, request) => {
        if (request.clearCacheEntry) {
          await config.store.removeItem(config.uuid)
        }
      }
    }
  })
}

const configureAdvReporting = async function () {
  await localforage.defineDriver(memoryDriver)

  return setup({
    baseURL: appConfig.api + "v7/admin/advance-reporting",
    headers: {
      common: {
        Accept: "application/json, text/plain, */*"
      }
    },
    withCredentials: axiosAuthConfig.withCredentials,
    withXSRFToken: axiosAuthConfig.withXSRFToken,
    cache: {
      maxAge: 30 * 60 * 1000,
      exclude: { query: false },
      store: forageStore,
      invalidate: async (config, request) => {
        if (request.clearCacheEntry) {
          await config.store.removeItem(config.uuid)
        }
      }
    }
  })
}

window.lf = forageStore
const cache = setupCache({
  maxAge: 5 * 60 * 1000,
  exclude: { query: false },
  invalidate: async (config, request) => {
    if (request.clearCacheEntry) {
      await config.store.removeItem(config.uuid)
    }
  }
})

const ai = {
  baseURL: appConfig.api + "v5",
  headers: {
    common: {}
  },
  withCredentials: axiosAuthConfig.withCredentials,
  withXSRFToken: axiosAuthConfig.withXSRFToken,
  adapter: cache.adapter
}
ai.headers.common["Accept"] = "application/json, text/plain, */*"

const api = axios.create(ai)

//api - in memory cache (cleared when you close the browser)
//configure - local storage cache
const ai6 = {
  baseURL: appConfig.api + "v6",
  headers: {
    common: {}
  },
  withCredentials: axiosAuthConfig.withCredentials,
  withXSRFToken: axiosAuthConfig.withXSRFToken,
  adapter: cache.adapter
}
ai6.headers.common["Accept"] = "application/json, text/plain, */*"

const api6 = axios.create(ai6)

const ai7 = {
  baseURL: appConfig.api + "v7",
  headers: {
    common: {}
  },
  withCredentials: appConfig.axios().withCredentials,
  adapter: cache.adapter
}
ai7.headers.common["Accept"] = "application/json, text/plain, */*"

const api7 = axios.create(ai7)

const aiNoCachev5 = {
  baseURL: appConfig.api + "v5",
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Cache-Control": "no-cache"
    }
  },
  withCredentials: axiosAuthConfig.withCredentials,
  withXSRFToken: axiosAuthConfig.withXSRFToken
}
const apiV5nocache = axios.create(aiNoCachev5)

const aiNoCachev6 = {
  baseURL: appConfig.api + "v6",
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  },
  withCredentials: axiosAuthConfig.withCredentials,
  withXSRFToken: axiosAuthConfig.withXSRFToken
}
const apiV6nocache = axios.create(aiNoCachev6)

const apiNoCachev7 = {
  baseURL: appConfig.api + "v7",
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  },
  withCredentials: axiosAuthConfig.withCredentials,
  withXSRFToken: axiosAuthConfig.withXSRFToken
}
const apiV7nocache = axios.create(apiNoCachev7)

const apiNoCachev8 = {
  baseURL: appConfig.api + "v8",
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  },
  withCredentials: axiosAuthConfig.withCredentials,
  withXSRFToken: axiosAuthConfig.withXSRFToken
}
const apiV8nocache = axios.create(apiNoCachev8)

const localDataNoCache = {
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  },
  withCredentials: axiosAuthConfig.withCredentials,
  withXSRFToken: axiosAuthConfig.withXSRFToken
}
const localNoCache = axios.create(localDataNoCache)

const visitorNoCacheV1 = {
  baseURL: appConfig.api + "visitor/v1",
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  },
  withCredentials: axiosAuthConfig.withCredentials,
  withXSRFToken: axiosAuthConfig.withXSRFToken
}

const visitorApiV1NoCache = axios.create(visitorNoCacheV1)

const queueNoCacheV1 = {
  baseURL: appConfig.api + "queue-management/v1",
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  },
  withCredentials: axiosAuthConfig.withCredentials,
  withXSRFToken: axiosAuthConfig.withXSRFToken
}

const queueApiV1NoCache = axios.create(queueNoCacheV1)

const advReportingNoCacheConfig = {
  baseURL: appConfig.api + "v7/admin/advance-reporting",
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  },
  withCredentials: axiosAuthConfig.withCredentials,
  withXSRFToken: axiosAuthConfig.withXSRFToken
}

const advReportingNoCacheApi = axios.create(advReportingNoCacheConfig)

const advReportingCache = setupCache({
  maxAge: 6 * 60 * 60 * 1000, // 6 hr caching for advance reporting data
  exclude: { query: false },
  store: advanceReportingForageStore,
  invalidate: async (config, request) => {
    if (request.clearCacheEntry) {
      await config.store.removeItem(config.uuid)
    }
  }
})

const advReportingCacheConfig = {
  baseURL: appConfig.api + "v7/admin/advance-reporting",
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  },
  withCredentials: axiosAuthConfig.withCredentials,
  withXSRFToken: axiosAuthConfig.withXSRFToken,
  adapter: advReportingCache.adapter
}

const advReportingCacheApi = axios.create(advReportingCacheConfig)

/**
 * Clears all advance reporting cache entries
 * Calling this before redirect so the next load fetches new data for the new school.
 */
const clearAdvanceReportingCache = async () => {
  try {
    await advanceReportingForageStore.clear()
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log("Error clearing advance reporting cache", err)
  }
}

export {
  api,
  api6,
  api7,
  configure,
  configure6,
  configure7,
  configureAdvReporting,
  forageStore,
  apiV5nocache,
  apiV6nocache,
  apiV7nocache,
  apiV8nocache,
  localNoCache,
  visitorApiV1NoCache,
  queueApiV1NoCache,
  advReportingNoCacheApi,
  advReportingCacheApi,
  clearAdvanceReportingCache
}
